import { z } from "zod";
export const companyCardBody = z.strictObject({ last4: z.string().regex(/^[0-9]{4}$/, "Enter exactly four digits").nullable() });
export const purchasePaymentBody = z.discriminatedUnion("method", [
  z.strictObject({ method: z.literal("ach") }),
  z.strictObject({ method: z.literal("credit_card") }),
  z.strictObject({ method: z.literal("efs"), efsCode: z.string().trim().min(1).max(100) }),
  z.strictObject({ method: z.literal("other"), otherNote: z.string().trim().min(1).max(250) }),
]);
export type PurchasePaymentBody = z.infer<typeof purchasePaymentBody>;
// The list, summary and CSV query, `purchasePaymentQuery`, is in purchase-payment-report.ts.
export interface PurchasePaymentRow {
  invoiceId: string; invoiceNumber: string; vendorName: string; date: string; currency: string; amount: string;
  method: string | null; cardOwnerId: string | null; cardOwnerName: string | null; cardLast4: string | null;
  efsCode: string | null; otherNote: string | null; status: string;
}
export function purchasePaymentLabel(row: Pick<PurchasePaymentRow, "method" | "cardLast4" | "cardOwnerName" | "efsCode" | "otherNote">): string {
  switch (row.method) {
    case "ach": return "ACH";
    case "credit_card": return `Credit card ending ${row.cardLast4} · ${row.cardOwnerName}`;
    case "efs": return `EFS · confirmation ${row.efsCode}`;
    case "other": return `Other · ${row.otherNote}`;
    default: return "Not recorded";
  }
}
